import async from '~/utils/async';
import RootStoreContext from '~/contexts/RootStoreContext';
import resolver from './ClientApplicationDetailLayout.resolver';
import ClientApplicationDetailLayout from './ClientApplicationDetailLayout';

export default async(resolver, { context: RootStoreContext })(
  ClientApplicationDetailLayout
);
